export default {
  months: {
    january: {
      en: 'January',
    },
    february: {
      en: 'February',
    },
    march: {
      en: 'March',
    },
    april: {
      en: 'April',
    },
    may: {
      en: 'May',
    },
    june: {
      en: 'June',
    },
    july: {
      en: 'July',
    },
    august: {
      en: 'August',
    },
    september: {
      en: 'September',
    },
    october: {
      en: 'October',
    },
    november: {
      en: 'November',
    },
    december: {
      en: 'December',
    },
  },
  days: {
    mo: {
      en: 'Mo',
    },
    tu: {
      en: 'Tu',
    },
    we: {
      en: 'We',
    },
    th: {
      en: 'Th',
    },
    fr: {
      en: 'Fr',
    },
    sa: {
      en: 'Sa',
    },
    su: {
      en: 'Su',
    },
  },
}
